import type { PropsWithChildren } from 'react';

import { ConfigProvider, App as AntDApp } from 'antd';

import { theme } from '../theme';

export const AntDProvider = ({ children }: PropsWithChildren) => (
  <ConfigProvider theme={theme}>
    <AntDApp>{children}</AntDApp>
  </ConfigProvider>
);
